module.exports = __webpack_public_path__ + "static/media/W19-0334_AW_350_Teen_LTO_2396x1473_EN.af90ffd7.jpg";